import { logEvent } from 'firebase/analytics';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '../query-keys';
import { useUserApi } from './use-user-api';
import { analytics } from '../../../firebase';
import { UserSettings, PatchUserSettings } from '../../../services/user-api';

export const useGetUserSettingsApi = (options?: { enabled?: boolean }) => {
  const userApi = useUserApi();
  return useQuery<UserSettings>({
    queryKey: QUERY_KEYS.learning.userSettings(),
    staleTime: 0,
    queryFn: () => userApi.settings.get(),
    enabled: options?.enabled,
  });
};

export const usePatchUserSettingsApi = () => {
  const userApi = useUserApi();
  const queryClient = useQueryClient();
  return useMutation<UserSettings, Error, PatchUserSettings>({
    mutationFn: (userSettings) => userApi.settings.patch(userSettings),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.learning.userSettings() });
      logEvent(analytics, 'user_settings_updated', {
        cookies_accepted: response.cookiesAccepted,
        accepted_terms_version: response.acceptedTermsVersion,
        application_id: response.applicationId,
        custom_user_id: response.cookiesAccepted ? response.userId : 'unknown',
      });
    },
  });
};
